import { store } from './store';

export const getStore = store?.getState;
